var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("BaseFilters", {
    attrs: {
      bem: _vm.bemBlock,
      disabled: _vm.loading,
      "filter-display-name": _vm.filterDisplayName,
      options: _vm.options,
      selected: _vm.refinementSelectedOptions,
      show: _vm.options && _vm.options.length > 1
    },
    on: { select: _vm.selectFilter, deselect: _vm.deselectFilter },
    scopedSlots: _vm._u([
      {
        key: "optionContent",
        fn: function(slotProps) {
          return [
            _c("img", {
              class: _vm.bemElement("option-image"),
              attrs: {
                src: slotProps.option.image,
                alt: _vm.filterDisplayName + " " + slotProps.option.displayValue
              }
            }),
            _vm._v("\n    " + _vm._s(slotProps.option.displayValue) + "\n  ")
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }